import { render, staticRenderFns } from "./JovianMultiplier.vue?vue&type=template&id=6b335bfc&"
import script from "./JovianMultiplier.vue?vue&type=script&lang=ts&"
export * from "./JovianMultiplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports